import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    position: relative;
    min-height: 400px;
`;
